module.exports = __webpack_public_path__ + "assets/reset.f9d1d6be.svg";